export default {
      id: "graph-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#graph",
      toString: function () {
        return this.url;
      }
    }